import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "card card-stretch shadow",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = {
  class: "card-body",
  style: {"padding":"15px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Төлөлтийн мэдээлэл")
const _hoisted_5 = { class: "card shadow" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Төлөлтийн мэдээлэл")
  ])
], -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { style: {"padding":"0 0"} }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  style: {"margin-top":"10px"},
  align: "center"
}
const _hoisted_11 = { class: "text-primary" }
const _hoisted_12 = {
  class: "card shadow",
  style: {"margin-top":"15px"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Буруу утгатай гүйлгээний мэдээлэл")
  ])
], -1)
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = { style: {"padding":"0 0"} }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Төлөх ")
const _hoisted_17 = {
  style: {"margin-top":"10px"},
  align: "center"
}
const _hoisted_18 = { class: "text-primary" }
const _hoisted_19 = {
  class: "card shadow",
  style: {"margin-top":"15px"}
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Лавлагааны эрх хаагдсан байгууллагын жагсаалт")
  ])
], -1)
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = { style: {"padding":"0 0"} }
const _hoisted_23 = {
  style: {"margin-top":"10px"},
  align: "center"
}
const _hoisted_24 = { class: "text-primary" }
const _hoisted_25 = {
  key: 0,
  class: "modal modal-fullscreen fade",
  tabindex: "-1",
  ref: "addPaymentOrg",
  id: "addPaymentOrg",
  "aria-hidden": "true",
  style: {"z-index":"1100 !important"}
}
const _hoisted_26 = { class: "modal-dialog modal-dialog-centered mw-1000px" }
const _hoisted_27 = { class: "modal-content" }
const _hoisted_28 = { class: "modal-header" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h2", null, "Төлбөр төлсөн байгууллага сонгох", -1)
const _hoisted_30 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_31 = { class: "svg-icon svg-icon-1" }
const _hoisted_32 = { class: "modal-body" }
const _hoisted_33 = { class: "table table-rounded table-striped border gy-7 gs-7" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", null, "Гүйлгээний дугаар:", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", null, "Гүйлгээний дүн:", -1)
const _hoisted_36 = { class: "el-input el-input--mini" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", null, "Гүйлгээний огноо:", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", null, "Банкны дугаар:", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", null, "Дансны нэр:", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", null, "Дансны дугаар:", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("td", null, "Гүйлгээний утга:", -1)
const _hoisted_42 = { colspan: "3" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "4",
    style: {"text-align":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Нэхэмжлэл төлөгдөөгүй байгууллагын жагсаалт")
  ])
], -1)
const _hoisted_44 = {
  colspan: "4",
  style: {"text-align":"center"}
}
const _hoisted_45 = { style: {"float":"left"} }
const _hoisted_46 = { style: {"float":"right","color":"#8492a6","font-size":"13px"} }
const _hoisted_47 = { style: {"float":"right","color":"#8492a6","font-size":"13px"} }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("td", null, "Нэхэмжлэлийн дугаар:", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("td", null, "Нэхэмжлэлийн дүн:", -1)
const _hoisted_50 = { class: "el-input el-input--mini" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("td", null, "Нэхэмжилсэн огноо:", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", null, "Төлөх дүн:", -1)
const _hoisted_53 = { class: "el-input el-input--mini" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("td", null, "Төлөв:", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("td", null, "Сүүлд гүйлгээ хийсэн огноо:", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("td", null, "Зөрүүтэй эсэх:", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("td", null, "Зөрүү дүн:", -1)
const _hoisted_58 = { class: "el-input el-input--mini" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_60 = {
  class: "row",
  style: {"padding":"10px 20px 10px 10px"}
}
const _hoisted_61 = /*#__PURE__*/_createTextVNode("Төлөх ")
const _hoisted_62 = /*#__PURE__*/_createTextVNode("Цуцлах ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_VueNumberFormat = _resolveComponent("VueNumberFormat")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_space, { size: "mini" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: this.paymentInfo.pageSize,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.paymentInfo.pageSize) = $event)),
                onChange: _ctx.handleChange,
                min: 1,
                max: 100,
                size: "mini"
              }, null, 8, ["modelValue", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_space, {
            size: "mini",
            class: "col-sm-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: this.paymentInfo.yearValue,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.paymentInfo.yearValue) = $event)),
                placeholder: "--Сонгох--",
                size: "mini",
                disabled: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentInfo.year, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.yearValue,
                      label: item.yearLabel,
                      value: item.yearValue
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_space, {
            size: "mini",
            class: "col-sm-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: this.paymentInfo.monthValue,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.paymentInfo.monthValue) = $event)),
                placeholder: "--Сонгох--",
                size: "mini"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentInfo.months, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.monthValue,
                      label: item.monthLabel,
                      value: item.monthValue
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_space, { size: "mini" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.paymentInfo.selectVal,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.paymentInfo.selectVal) = $event)),
                placeholder: "--Сонгох--",
                size: "mini",
                onChange: _cache[4] || (_cache[4] = ($event: any) => (
              this.paymentInfo.selectOrgVal =
                this.paymentInfo.selectVal === '07'
                  ? '*'
                  : this.paymentInfo.selectOrgVal
            ))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentInfo.statusType, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.selectVal,
                      label: item.selectLabel,
                      value: item.selectVal
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (this.paymentInfo.selectVal !== '07')
            ? (_openBlock(), _createBlock(_component_el_space, {
                key: 0,
                size: "mini"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.paymentInfo.selectOrgVal,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.paymentInfo.selectOrgVal) = $event)),
                    placeholder: "--Сонгох--",
                    filterable: "",
                    size: "mini"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        value: "*",
                        label: "Бүгд"
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOrgList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.selectOrgVal,
                          label: item.selectOrgLabel,
                          value: item.selectOrgVal
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_space, { size: "mini" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                "prefix-icon": "el-icon-search",
                modelValue: _ctx.paymentInfo.invoiceSearch,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.paymentInfo.invoiceSearch) = $event)),
                size: "mini",
                placeholder: "Хайх утга аа оруулна уу..."
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        true
          ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: 
            this.paymentInfo.tableData
              .filter(data => {
                return this.paymentInfo.selectOrgVal === '*'
                  ? true
                  : data.orgcode.includes(this.paymentInfo.selectOrgVal);
              })
              .filter(data => {
                return this.paymentInfo.selectVal === '07'
                  ? true
                  : data.orgtype.includes(this.paymentInfo.selectVal);
              })
              .filter(data => {
                return (
                  !this.paymentInfo.monthValue ||
                  data.month.includes(this.paymentInfo.monthValue)
                );
              })
              .filter(data => {
                return (
                  !this.paymentInfo.yearValue ||
                  data.year.includes(this.paymentInfo.yearValue)
                );
              })
              .filter(
                data =>
                  !this.paymentInfo.invoiceSearch ||
                  data.searchfield.includes(
                    this.paymentInfo.invoiceSearch.toLowerCase()
                  )
              )
              .slice(
                this.paymentInfo.pageSize * this.paymentInfo.page -
                  this.paymentInfo.pageSize,
                this.paymentInfo.pageSize * this.paymentInfo.page
              )
          ,
              style: {"width":"100%","margin-top":"20px"},
              size: "mini",
              border: "",
              "element-loading-text": "Өгөгдөл татаж байна...",
              "empty-text": "Өгөгдөл байхгүй байна.",
              "cell-style": { textAlign: 'center' },
              "header-cell-style": { textAlign: 'center' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "№",
                  width: "60"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Нэхэмжлэлийн дугаар",
                  prop: "invoiceNumber",
                  sortable: "",
                  width: "200px"
                }, {
                  default: _withCtx((scope) => [
                    _withDirectives((_openBlock(), _createElementBlock("span", {
                      class: "customized-link-span",
                      onClick: ($event: any) => (_ctx.getInvoice(scope.row.invoiceNumber))
                    }, [
                      _createTextVNode(_toDisplayString(scope.row.invoiceNumber), 1)
                    ], 8, _hoisted_9)), [
                      [
                        _directive_loading,
                        this.downloadInvoice,
                        void 0,
                        {
                          fullscreen: true,
                          lock: true
                        }
                      ]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Нэхэмжилсэн огноо",
                  prop: "invoiceDate",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Нэхэмжилсэн дүн (төг)",
                  prop: "invoiceAmount",
                  formatter: _ctx.$filters.formatPrice,
                  sortable: ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Төлөх дүн (төг)",
                  prop: "payableAmount",
                  formatter: _ctx.$filters.formatPrice,
                  sortable: ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Төлсөн дүн (төг)",
                  prop: "voucherAmount",
                  formatter: _ctx.$filters.formatPrice,
                  sortable: ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Байгууллагын дугаар",
                  prop: "orgcode",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Байгууллагын нэр",
                  prop: "orgname",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Төлөв",
                  prop: "status",
                  sortable: ""
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_tag, {
                      type: 
                  scope.row.status === 'C'
                    ? 'danger'
                    : scope.row.diffStatus === 'D'
                    ? 'warning'
                    : scope.row.diffStatus === 'M'
                    ? 'success'
                    : 'success'
                ,
                      "disable-transitions": ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.status === "C"
                    ? "Төлөгдөөгүй"
                    : scope.row.diffStatus === "D"
                    ? "Дутуу төлсөн"
                    : scope.row.diffStatus === "M"
                    ? "Илүү төлсөн"
                    : "Төлөгдсөн"), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Зөрүү дүн",
                  prop: "amntDiff",
                  formatter: _ctx.$filters.formatPrice,
                  sortable: ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Төлөгдсөн огноо",
                  prop: "paidDate",
                  sortable: ""
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, this.loadingTable]
            ])
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_pagination, {
              background: "",
              layout: "prev, pager, next",
              onCurrentChange: _ctx.handleCurrentChange,
              "page-size": _ctx.paymentInfo.pageSize,
              total: this.paymentInfo.tableData.length
            }, null, 8, ["onCurrentChange", "page-size", "total"])
          ]),
          _createElementVNode("div", _hoisted_11, " Бичлэгийн тоо: " + _toDisplayString(this.paymentInfo.tableData.length), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_el_space, { size: "mini" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: this.voucherList.pageSize,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.voucherList.pageSize) = $event)),
                onChange: _ctx.handleChangeVoucherList,
                min: 1,
                max: 100,
                size: "mini"
              }, null, 8, ["modelValue", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_space, {
            size: "mini",
            class: "col-sm-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: this.voucherList.yearValue,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((this.voucherList.yearValue) = $event)),
                placeholder: "--Он--",
                size: "mini"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.voucherList.year, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.yearValue,
                      label: item.yearLabel,
                      value: item.yearValue
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_space, {
            size: "mini",
            class: "col-sm-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: this.voucherList.monthValue,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((this.voucherList.monthValue) = $event)),
                placeholder: "--Сар--",
                size: "mini"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.voucherList.months, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.monthValue,
                      label: item.monthLabel,
                      value: item.monthValue
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_space, { size: "mini" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                "prefix-icon": "el-icon-search",
                modelValue: _ctx.voucherList.sttSearch,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.voucherList.sttSearch) = $event)),
                size: "mini",
                placeholder: "Хайх утга аа оруулна уу..."
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        true
          ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: 
            this.voucherList.tableData
              .filter(data => {
                return (
                  !this.voucherList.monthValue ||
                  data.month.includes(this.voucherList.monthValue)
                );
              })
              .filter(data => {
                return (
                  !this.voucherList.yearValue ||
                  data.year.includes(this.voucherList.yearValue)
                );
              })
              .filter(
                data =>
                  !this.voucherList.sttSearch ||
                  data.searchfield.includes(
                    this.voucherList.sttSearch.toLowerCase()
                  )
              )
              .slice(
                this.voucherList.pageSize * this.voucherList.page -
                  this.voucherList.pageSize,
                this.voucherList.pageSize * this.voucherList.page
              )
          ,
              style: {"width":"100%","margin-top":"20px"},
              size: "mini",
              "element-loading-text": "Өгөгдөл татаж байна...",
              "empty-text": "Өгөгдөл байхгүй байна.",
              "cell-style": { textAlign: 'center' },
              "header-cell-style": { textAlign: 'center' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "№",
                  width: "60"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Гүйлгээний дугаар",
                  prop: "voucherid",
                  sortable: "",
                  width: "150px"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Банкны дугаар",
                  prop: "bankcode",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Дансны дугаар",
                  prop: "accountNumber",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Дансны нэр",
                  prop: "accountName",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Гүйлгээний дүн",
                  prop: "amount",
                  formatter: _ctx.$filters.formatPrice,
                  sortable: ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Гүйлгээний утга",
                  prop: "narration",
                  width: "200px",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Гүйлгээний огноо",
                  prop: "voucherdate",
                  formatter: _ctx.$filters.formatDateYMD,
                  sortable: ""
                }, null, 8, ["formatter"]),
                (this.isu)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      fixed: "right"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          size: "mini",
                          type: "primary",
                          plain: "",
                          "data-bs-target": "#addPaymentOrg",
                          "data-bs-toggle": "modal",
                          onClick: ($event: any) => (_ctx.fillVoucherList(scope.row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_16
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, this.loadingTable]
            ])
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_pagination, {
              background: "",
              layout: "prev, pager, next",
              onCurrentChange: _ctx.handleCurrentChangeVoucherList,
              "page-size": _ctx.voucherList.pageSize,
              total: this.voucherList.tableData.length
            }, null, 8, ["onCurrentChange", "page-size", "total"])
          ]),
          _createElementVNode("div", _hoisted_18, " Бичлэгийн тоо: " + _toDisplayString(this.voucherList.tableData.length), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_el_space, { size: "mini" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: this.inqClosedOrg.pageSize,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((this.inqClosedOrg.pageSize) = $event)),
                onChange: _ctx.handleChangeInqClosed,
                min: 1,
                max: 100,
                size: "mini"
              }, null, 8, ["modelValue", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_space, { size: "mini" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                "prefix-icon": "el-icon-search",
                modelValue: _ctx.inqClosedOrg.inqClsSearch,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.inqClosedOrg.inqClsSearch) = $event)),
                size: "mini",
                placeholder: "Хайх утга аа оруулна уу..."
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        true
          ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: 
            this.inqClosedOrg.tableData
              .filter(
                data =>
                  !this.inqClosedOrg.inqClsSearch ||
                  data.searchfield.includes(
                    this.inqClosedOrg.inqClsSearch.toLowerCase()
                  )
              )
              .slice(
                this.inqClosedOrg.pageSize * this.inqClosedOrg.page -
                  this.inqClosedOrg.pageSize,
                this.inqClosedOrg.pageSize * this.inqClosedOrg.page
              )
          ,
              style: {"width":"100%","margin-top":"20px"},
              border: "",
              size: "mini",
              "element-loading-text": "Өгөгдөл татаж байна...",
              "empty-text": "Өгөгдөл байхгүй байна."
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "№",
                  width: "60"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Байгууллагын нэр",
                  prop: "orgname",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Байгууллагын код",
                  prop: "orgcode",
                  sortable: ""
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, this.loadingTable]
            ])
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_pagination, {
              background: "",
              layout: "prev, pager, next",
              onCurrentChange: _ctx.handleCurrentChangeInqClosed,
              "page-size": _ctx.inqClosedOrg.pageSize,
              total: this.inqClosedOrg.tableData.length
            }, null, 8, ["onCurrentChange", "page-size", "total"])
          ]),
          _createElementVNode("div", _hoisted_24, " Бичлэгийн тоо: " + _toDisplayString(this.inqClosedOrg.tableData.length), 1)
        ])
      ])
    ]),
    true
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("span", _hoisted_31, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Close.svg" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("table", _hoisted_33, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_34,
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_input, {
                          modelValue: this.voucherList.selectedVoucher.voucherid,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((this.voucherList.selectedVoucher.voucherid) = $event)),
                          readonly: "",
                          size: "mini"
                        }, null, 8, ["modelValue"])
                      ]),
                      _hoisted_35,
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_component_VueNumberFormat, {
                            class: "el-input__inner",
                            readonly: "",
                            value: this.voucherList.selectedVoucher.amount,
                            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((this.voucherList.selectedVoucher.amount) = $event))
                          }, null, 8, ["value"])
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_37,
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_input, {
                          modelValue: this.voucherList.selectedVoucher.voucherdate,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((this.voucherList.selectedVoucher.voucherdate) = $event)),
                          readonly: "",
                          size: "mini"
                        }, null, 8, ["modelValue"])
                      ]),
                      _hoisted_38,
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_input, {
                          modelValue: this.voucherList.selectedVoucher.bankcode,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((this.voucherList.selectedVoucher.bankcode) = $event)),
                          readonly: "",
                          size: "mini"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_39,
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_input, {
                          modelValue: this.voucherList.selectedVoucher.accountName,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((this.voucherList.selectedVoucher.accountName) = $event)),
                          readonly: "",
                          size: "mini"
                        }, null, 8, ["modelValue"])
                      ]),
                      _hoisted_40,
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_input, {
                          modelValue: this.voucherList.selectedVoucher.accountNumber,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((this.voucherList.selectedVoucher.accountNumber) = $event)),
                          readonly: "",
                          size: "mini"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_41,
                      _createElementVNode("td", _hoisted_42, [
                        _createVNode(_component_el_input, {
                          modelValue: this.voucherList.selectedVoucher.narration,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((this.voucherList.selectedVoucher.narration) = $event)),
                          readonly: "",
                          size: "mini"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _hoisted_43,
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_44, [
                        _createVNode(_component_el_select, {
                          modelValue: this.voucherList.selectedPayableInvoice,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((this.voucherList.selectedPayableInvoice) = $event)),
                          placeholder: "--Сонгох--",
                          size: "mini",
                          filterable: "",
                          class: "col-lg-12",
                          onChange: _cache[21] || (_cache[21] = ($event: any) => {
                        this.voucherList.savePaymentData.invoiceNumber = this.voucherList.selectedPayableInvoice;
                        this.voucherList.selectedInvoice = this.voucherList.payableVoucherList.find(
                          data => {
                            return (
                              data.invoiceNumber ===
                              this.voucherList.selectedPayableInvoice
                            );
                          }
                        );
                      })
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.voucherList.payableVoucherList, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.invoiceNumber,
                                label: item.orgname,
                                value: item.invoiceNumber
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_45, _toDisplayString(item.orgname), 1),
                                  _createElementVNode("span", _hoisted_46, "-- дүн: " + _toDisplayString(item.payableAmount), 1),
                                  _createElementVNode("span", _hoisted_47, "Нэхэмжлэлийн дугаар: " + _toDisplayString(item.invoiceNumber) + " -- ", 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    (this.voucherList.selectedPayableInvoice !== '')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("tr", null, [
                            _hoisted_48,
                            _createElementVNode("td", null, [
                              _createVNode(_component_el_input, {
                                modelValue: this.voucherList.selectedInvoice.invoiceNumber,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((this.voucherList.selectedInvoice.invoiceNumber) = $event)),
                                readonly: "",
                                size: "mini"
                              }, null, 8, ["modelValue"])
                            ]),
                            _hoisted_49,
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_50, [
                                _createVNode(_component_VueNumberFormat, {
                                  class: "el-input__inner",
                                  readonly: "",
                                  value: 
                            this.voucherList.selectedInvoice.invoiceAmount
                          ,
                                  "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((
                            this.voucherList.selectedInvoice.invoiceAmount
                          ) = $event))
                                }, null, 8, ["value"])
                              ])
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_51,
                            _createElementVNode("td", null, [
                              _createVNode(_component_el_input, {
                                modelValue: this.voucherList.selectedInvoice.invoiceDate,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((this.voucherList.selectedInvoice.invoiceDate) = $event)),
                                readonly: "",
                                size: "mini"
                              }, null, 8, ["modelValue"])
                            ]),
                            _hoisted_52,
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_53, [
                                _createVNode(_component_VueNumberFormat, {
                                  class: "el-input__inner",
                                  readonly: "",
                                  value: 
                            this.voucherList.selectedInvoice.payableAmount
                          ,
                                  "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((
                            this.voucherList.selectedInvoice.payableAmount
                          ) = $event))
                                }, null, 8, ["value"])
                              ])
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_54,
                            _createElementVNode("td", null, [
                              _createVNode(_component_el_input, {
                                "model-value": 
                          this.voucherList.selectedInvoice.status === 'C'
                            ? 'Шинээр үүсэн'
                            : 'Зөрүүтэй төлсөн'
                        ,
                                readonly: "",
                                size: "mini"
                              }, null, 8, ["model-value"])
                            ]),
                            _hoisted_55,
                            _createElementVNode("td", null, [
                              _createVNode(_component_el_input, {
                                modelValue: this.voucherList.selectedInvoice.paidDate,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((this.voucherList.selectedInvoice.paidDate) = $event)),
                                readonly: "",
                                size: "mini"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_56,
                            _createElementVNode("td", null, [
                              _createVNode(_component_el_input, {
                                "model-value": 
                          this.voucherList.selectedInvoice.diffStatus === 'D'
                            ? 'Дутуу төлсөн'
                            : this.voucherList.selectedInvoice.diffStatus ===
                              'M'
                            ? 'Илүү төлсөн'
                            : 'Байхгүй'
                        ,
                                readonly: "",
                                size: "mini"
                              }, null, 8, ["model-value"])
                            ]),
                            _hoisted_57,
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_58, [
                                _createVNode(_component_VueNumberFormat, {
                                  class: "el-input__inner",
                                  readonly: "",
                                  value: 
                            this.voucherList.selectedInvoice.amntDiff
                          ,
                                  "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((
                            this.voucherList.selectedInvoice.amntDiff
                          ) = $event))
                                }, null, 8, ["value"])
                              ])
                            ])
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _hoisted_59,
              _createElementVNode("div", _hoisted_60, [
                _createVNode(_component_el_row, {
                  type: "flex",
                  justify: "end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "success",
                      plain: "",
                      size: "mini",
                      class: "col-lg-3",
                      onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.savePayment()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_61
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "info",
                      plain: "",
                      size: "mini",
                      class: "col-lg-3",
                      "data-bs-dismiss": "modal"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_62
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ], 512))
      : _createCommentVNode("", true)
  ], 64))
}